import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import axios from 'axios'
import { useMutation } from '@tanstack/vue-query'
import { AuToast } from '~/stores/toasts'

export default function useImageUpload() {
  const progress = ref(0)
  const imageSrc = ref('')

  const { t } = useI18n()

  const uploadImageFn = async (event: Event) => {
    const target = event.target as HTMLInputElement
    if (!target.files || target.files.length === 0)
      return

    const image = target.files[0]
    const form = new FormData()

    form.append('absolute_url', '1')
    form.append('file', image)

    const response = await axios.post('/image/upload', form, {
      baseURL: import.meta.env.VITE_AUNIVERS_SITEURL,
      withCredentials: true,
      headers: {
        'Content-Type': image.type,
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          progress.value = Math.round((progressEvent.loaded / progressEvent.total) * 100)
        }
      },
    })

    imageSrc.value = response.data.src
  }

  const uploadImage = useMutation({
    mutationFn: uploadImageFn,
    onSettled: (_, error) => error
      ? AuToast.error(t('formWriter.toasts.imageUploadError'))
      : AuToast.success(t('formWriter.toasts.imageUpload')),
  })

  const reset = () => {
    progress.value = 0
    imageSrc.value = ''
  }

  async function downloadImage(url: string) {
    const a = document.createElement('a')
    const image = await fetch(url, { credentials: 'include' })
    const objectUrl = URL.createObjectURL(await image.blob())

    a.href = objectUrl
    a.download = ''

    a.click()

    URL.revokeObjectURL(objectUrl)
  }

  return {
    uploadImage,
    progress,
    imageSrc,
    reset,
    downloadImage,
  }
}
